export const AGREEMENT_WITHDRAW_FETCH = 'AGREEMENT_WITHDRAW_FETCH';
export const AGREEMENT_WITHDRAW_CONFIRM = 'AGREEMENT_WITHDRAW_CONFIRM';
